"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFirstLetter = exports.addHoursOnDataTime = exports.getTimeFormat = exports.GOOGLE_MAP_KEY = void 0;
exports.changeNumberUSFormat = changeNumberUSFormat;
exports.replaceUnderscoreToSpace = replaceUnderscoreToSpace;
exports.dobFormat = dobFormat;
exports.dateToTimestamp = dateToTimestamp;
exports.isCompareToday = isCompareToday;
exports.arrayLength = arrayLength;
exports.objectLength = objectLength;
exports.changeNumberNormalFormat = changeNumberNormalFormat;
exports.trim = trim;
exports.catchError = catchError;
exports.catchColorFullError = catchColorFullError;
exports.fileType = fileType;
exports.toUpperCase = toUpperCase;
exports.toTitleCase = toTitleCase;
exports.breakCallByReference = breakCallByReference;
exports.JsonParse = JsonParse;
exports.JsonStringify = JsonStringify;
exports.getLastSyncedAt = getLastSyncedAt;
exports.disableRightClick = disableRightClick;
exports.cleanData = cleanData;
exports.base64ToFile = base64ToFile;
exports.googleMapImageMaker = googleMapImageMaker;
exports.redirectGoogleMapWithLatLng = redirectGoogleMapWithLatLng;
exports.ngxMaterialNextTime = ngxMaterialNextTime;
exports.combineDateAndTime = combineDateAndTime;
exports.dateEndTime = dateEndTime;
exports.dateStartTime = dateStartTime;
exports.getLinkOnText = getLinkOnText;
exports.bytesToSize = bytesToSize;
exports.deleteLocalKeys = deleteLocalKeys;
exports.debounce = debounce;
exports.matCalendarAttributeFormate = matCalendarAttributeFormate;
exports.offset = offset;
exports.dynamicSort = dynamicSort;
exports.randomIdGenerator = randomIdGenerator;
exports.thumbnail = thumbnail;
exports.detectLink = detectLink;
exports.getDistanceFromLatLonInKm = getDistanceFromLatLonInKm;
exports.deg2rad = deg2rad;
exports.detectionBrowser = detectionBrowser;
exports.detectMobileBrowser = detectMobileBrowser;
exports.substrInBetween = substrInBetween;
exports.substrInBetweenNew = substrInBetweenNew;
exports.substrInBetweenInclusive = substrInBetweenInclusive;
exports.getEmailAddress = getEmailAddress;
exports.phoneNumbers = phoneNumbers;
exports.buildLocalDate = buildLocalDate;
exports.getDOB = getDOB;
exports.copyText = copyText;
exports.isString = isString;
const regex_1 = require("./regex");
let debounceTimer;
exports.GOOGLE_MAP_KEY = `AIzaSyAEq6yrfaANCX1hfcleqH0hJECalAnk0ps`;
function changeNumberUSFormat(number) {
    if (number) {
        try {
            return number.replace(/^(\d{0,3})(\d{0,3})(\d{0,20})/, "$1-$2-$3");
        }
        catch (error) {
            return "";
        }
    }
    else {
        return "";
    }
}
function replaceUnderscoreToSpace(text) {
    try {
        return text.replace(/_/g, " ");
    }
    catch (error) {
        return "";
    }
}
function dobFormat(date) {
    if (date) {
        try {
            const newDate = new Date(date);
            let dd = newDate.getDate();
            let mm = newDate.getMonth() + 1;
            if (dd < 10) {
                dd = "0" + dd;
            }
            if (mm < 10) {
                mm = "0" + mm;
            }
            return `${mm}/${dd}/${newDate.getFullYear()}`;
        }
        catch (error) {
            return "";
        }
    }
    else {
        return "";
    }
}
function dateToTimestamp(date) {
    if (date) {
        try {
            return +new Date(date);
        }
        catch (error) {
            return date;
        }
    }
    else {
        return date;
    }
}
function isCompareToday(sDate, eDate) {
    let startDate = new Date(); //Default today
    //first date
    if (sDate) {
        startDate = new Date(sDate);
    }
    let endDate = new Date(eDate);
    startDate.setHours(0, 0, 0, 0);
    endDate.setHours(0, 0, 0, 0);
    return +startDate === +endDate;
}
function arrayLength(data) {
    try {
        return data.length;
    }
    catch (error) {
        return 0;
    }
}
function objectLength(data) {
    try {
        return Object.keys(data).length;
    }
    catch (error) {
        return 0;
    }
}
function changeNumberNormalFormat(number) {
    if (number) {
        try {
            return number.replace(/-/g, "");
        }
        catch (error) {
            return "";
        }
    }
    else {
        return "";
    }
}
function trim(value) {
    if (value) {
        try {
            return value.trim();
        }
        catch (error) {
            return "";
        }
    }
    else {
        return "";
    }
}
function catchError(error) {
    console.log(error);
}
function catchColorFullError(message, color = "#dc0b0b", background = "#222") {
    try {
        const consoleStyle = `color: ${color}; font-size: 16px;background: ${background}`;
        console.log(`%c${message}`, consoleStyle);
    }
    catch (error) {
        //error
    }
}
function fileType(value) {
    try {
        const type = value.split(".");
        return type[type.length - 1].toUpperCase();
    }
    catch (error) {
        return "JPG";
    }
}
function toUpperCase(value) {
    try {
        return value.toUpperCase();
    }
    catch (error) {
        return value;
    }
}
function toTitleCase(str) {
    try {
        return str.replace(/\w\S*/g, function (txt) {
            return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        });
    }
    catch (error) {
        return str;
    }
}
function breakCallByReference(data) {
    try {
        return JSON.parse(JSON.stringify(data));
    }
    catch (error) {
        return data;
    }
}
function JsonParse(data) {
    try {
        return JSON.parse(data);
    }
    catch (error) {
        return data;
    }
}
function JsonStringify(data) {
    return JSON.stringify(data);
}
function getLastSyncedAt(date) {
    if (date) {
        return +new Date(date);
    }
    else {
        return +new Date();
    }
}
function disableRightClick(event) {
    event.preventDefault();
}
/**
 * @function cleanData
 * delete all empty keys
 */
function cleanData(value) {
    // Deep Copy object to so that actual does not changes
    const newValue = JSON.parse(JSON.stringify(value));
    // iterate newValue and remove empty fields
    (function isEmpty(data) {
        if (typeof data === "object" && data !== null) {
            if (Array.isArray(data)) {
                const indexToRemove = [];
                data.forEach((item, index) => {
                    if (isEmpty(item)) {
                        indexToRemove.unshift(index);
                    }
                });
                indexToRemove.forEach((item) => {
                    data.splice(item, 1);
                });
            }
            else {
                Object.keys(data).forEach((key) => {
                    let trimValue = data[key];
                    if (trimValue && typeof trimValue === "string") {
                        trimValue = trimValue.trim();
                    }
                    if (isEmpty(trimValue)) {
                        delete data[key];
                    }
                });
                if (!Object.keys(data).length) {
                    return true;
                }
            }
        }
        return data === null || data === undefined || data === "";
    })(newValue);
    return newValue;
}
function base64ToFile(dataurl, fileName) {
    let arr = dataurl.split(","), mime = arr[0].match(/:(.*?);/)[1], bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    // @ts-ignore
    if (!navigator.msSaveBlob) {
        // detect if not Edge
        return new File([u8arr], fileName ? fileName : "hg", { type: mime });
    }
    else {
        return new Blob([u8arr], { type: mime });
    }
}
function googleMapImageMaker(data) {
    const imagePath = `https://maps.googleapis.com/maps/api/staticmap?zoom=15&size=350x350&maptype=roadmap&markers=color:red%7Clabel:S%7C${data.lat},${data.lng}&key=${exports.GOOGLE_MAP_KEY}`;
    return imagePath;
}
function redirectGoogleMapWithLatLng(location) {
    try {
        const cord = location.coordinates;
        const imagePath = `https://www.google.com/maps?q=${cord[1]},${cord[0]}`;
        return imagePath;
    }
    catch (error) {
        return `https://www.google.com/maps?q=${0},${0}`;
    }
}
function ngxMaterialNextTime(startTime) {
    //Set dummy date for getting next time
    const date = new Date(`January 29, 2001 ${startTime}`);
    date.setHours(date.getHours() + 2);
    return date.toLocaleString("en-US", {
        hour: "numeric",
        minute: "numeric",
        hour12: true,
    });
}
function combineDateAndTime(date, time) {
    try {
        if (date && time) {
            let dateWithTime;
            if (typeof time == "object") {
                dateWithTime = new Date(time);
            }
            else {
                //January 29 dummy date -> getting only time
                dateWithTime = new Date(`January 29, 2001 ${time ? time : "23:59"}`);
            }
            let formatDate = new Date(date);
            formatDate.setHours(dateWithTime.getHours());
            formatDate.setMinutes(dateWithTime.getMinutes());
            if (formatDate instanceof Date) {
                return +new Date(formatDate.toUTCString()).setSeconds(0, 0);
            }
            else {
                alert("Date type not valid please enter valid date");
            }
        }
        else {
            return "";
        }
    }
    catch (error) {
        return "";
    }
}
function dateEndTime(date) {
    const modifyDate = new Date(date).setHours(23, 59);
    return +new Date(modifyDate);
}
function dateStartTime(date) {
    let setHours = new Date(date);
    setHours.setHours(0, 0, 0, 0);
    return setHours;
}
function getLinkOnText(text) {
    try {
        const linkArray = [];
        text.replace(regex_1.Regex.DETECT_LINKS_AND_EMAILS, (fullMatch, boundary, detectedLink) => {
            let newURL = detectedLink;
            const isEmail = regex_1.Regex.email.test(newURL);
            if (isEmail) {
                newURL = `mailto:${newURL}`;
            }
            else {
                if (!newURL.toLowerCase().startsWith("http") &&
                    !newURL.startsWith("mailto:")) {
                    newURL = `http://${newURL}`;
                }
            }
            linkArray.push(newURL);
            return "";
        });
        return linkArray;
    }
    catch (error) {
        return [];
    }
}
function bytesToSize(bytes, decimals = 2) {
    try {
        const k = 1024;
        const dm = decimals < 0 ? 0 : decimals;
        const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
    }
    catch (error) {
        return "1 Byte";
    }
}
/**
 * @param data Object
 * This function delete all local keys UI/UX
 */
function deleteLocalKeys(data) {
    try {
        const newData = breakCallByReference(data);
        delete newData.blobURL;
        delete newData.thumbnailBlobURL;
        delete newData.senderTimestamp;
        delete newData.OID;
        return newData;
    }
    catch (error) {
        return data;
    }
}
function debounce(func, timer = 1000) {
    return function () {
        // @ts-ignore
        const context = this;
        const args = arguments;
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(function () {
            func.apply(context, args);
        }, timer);
    };
}
function matCalendarAttributeFormate(dt) {
    try {
        const date = new Date(dt);
        const dtf = new Intl.DateTimeFormat("en", {
            year: "numeric",
            month: "long",
            day: "numeric",
        }).format(date);
        return dtf;
    }
    catch (error) {
        return dt;
    }
}
function offset() {
    try {
        return new Date().getTimezoneOffset();
    }
    catch (error) {
        return -300;
    }
}
function dynamicSort(data, property) {
    try {
        return data.sort(function (a, b) {
            return a[property].localeCompare(b[property]);
        });
    }
    catch (error) {
        return data;
    }
}
function randomIdGenerator(length) {
    try {
        let result = "";
        let characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
        let charactersLength = characters.length;
        for (let i = 0; i < length; i++) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }
        return result;
    }
    catch (error) {
        return "health";
    }
}
function thumbnail(value) {
    try {
        const fileName = value.substring(value.lastIndexOf("/") + 1);
        const basePath = value.split(fileName)[0];
        const imageUrl = `${basePath}thumbnail/${fileName}`;
        return imageUrl;
    }
    catch (error) {
        return value;
    }
}
function detectLink(message) {
    try {
        return message.replace(regex_1.Regex.FIND_LINKS, (url) => {
            let newURL = url;
            let title = null;
            //For URL
            const findULR = url.match(regex_1.Regex.LINK);
            if (findULR && newURL.toLowerCase().indexOf("http") == -1) {
                newURL = `http://${newURL}`;
            }
            //FOR EMAIL
            const findEmail = url.match(regex_1.Regex.LINK_EMAIL);
            if (findEmail && newURL.indexOf("@") !== -1) {
                newURL = `mailto:${newURL}`;
                title = `Contact ${url} in HomeHealthNotify`;
            }
            //FOR HOME ADDRESS
            const findAddress = url.match(regex_1.Regex.LINK_ADDRESS);
            if (findAddress && findAddress.length) {
                newURL = `https://maps.google.com/?q=${newURL}`;
            }
            return `<a class="chat_link" title="${title ? title : url}" target="_blank" rel="noopener noreferrer" href="${newURL}">${url}</a>`;
        });
    }
    catch (error) {
        return message;
    }
}
function getDistanceFromLatLonInKm(lat1, lon1, lat2, lon2) {
    const R = 6371; // Radius of the earth in km
    const dLat = deg2rad(lat2 - lat1); // deg2rad below
    const dLon = deg2rad(lon2 - lon1);
    const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(deg2rad(lat1)) *
            Math.cos(deg2rad(lat2)) *
            Math.sin(dLon / 2) *
            Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const d = R * c; // Distance in km
    return d;
}
function deg2rad(deg) {
    return deg * (Math.PI / 180);
}
const getTimeFormat = (_Date) => {
    try {
        const dt = new Date(_Date);
        return dt.toLocaleString("en-US", {
            hour: "numeric",
            minute: "numeric",
            hour12: true,
        });
    }
    catch (error) {
        return "N/A";
    }
};
exports.getTimeFormat = getTimeFormat;
const addHoursOnDataTime = (_Date, hours = 2) => {
    try {
        const dt = new Date(_Date);
        dt.setHours(dt.getHours() + hours);
        return dt.toLocaleString("en-US", {
            hour: "numeric",
            minute: "numeric",
            hour12: true,
        });
    }
    catch (error) {
        return "N/A";
    }
};
exports.addHoursOnDataTime = addHoursOnDataTime;
const getFirstLetter = (value) => {
    try {
        const _vlu = value.split("")[0];
        return toUpperCase(_vlu);
    }
    catch (error) {
        return "H";
    }
};
exports.getFirstLetter = getFirstLetter;
function detectionBrowser() {
    try {
        const sUsrAg = navigator.userAgent;
        if (sUsrAg.indexOf("Opera") > -1 || sUsrAg.indexOf("OPR") > -1) {
            return "OPERA";
        }
        else if (sUsrAg.indexOf("Edg") > -1) {
            return "MICROSOFT_EDGE";
        }
        else if (sUsrAg.indexOf("Chrome") > -1) {
            return "CHROME";
        }
        else if (sUsrAg.indexOf("Safari") > -1) {
            return "SAFARI";
        }
        else if (sUsrAg.indexOf("Firefox") > -1) {
            return "FIREFOX";
        }
        else if (sUsrAg.indexOf("SamsungBrowser") > -1) {
            return "SAMSUNG_INTERNET";
        }
        else if (sUsrAg.indexOf("Trident") > -1) {
            return "INTERNET_EXPLORER";
        }
        else {
            return "UNKNOWN";
        }
    }
    catch (error) {
        return "UNKNOWN";
    }
}
function detectMobileBrowser() {
    let check = false;
    (function (a) {
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) ||
            /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4)))
            check = true;
    })(navigator.userAgent || navigator.vendor || window.opera);
    return check;
}
function substrInBetween(whole_str, startText, endText) {
    //**startText or EndText missing from whole_str*/
    if (whole_str.indexOf(startText) === -1 ||
        whole_str.indexOf(endText) === -1) {
        return "";
    }
    const betweenString = whole_str.substring(whole_str.lastIndexOf(startText) + startText.length, whole_str.lastIndexOf(endText));
    const sessionFirst = betweenString.slice(0, betweenString.indexOf(endText));
    /**sessionFirst not found*/
    if (!sessionFirst) {
        return "";
    }
    /**Data found*/
    return sessionFirst.trim();
}
function substrInBetweenNew(wholeString, startText, endText) {
    const startIndex = wholeString.indexOf(startText);
    if (startIndex === -1) {
        return "";
    }
    const endIndex = wholeString.indexOf(endText, startIndex);
    if (endIndex === -1) {
        return "";
    }
    return wholeString.substring(startIndex + startText.length, endIndex);
}
function substrInBetweenInclusive(wholeString, startText, endText) {
    const startIndex = wholeString.indexOf(startText);
    if (startIndex === -1) {
        return "";
    }
    const endIndex = wholeString.indexOf(endText, startIndex);
    if (endIndex === -1) {
        return "";
    }
    const betweenString = wholeString.substring(startIndex, endIndex + endText.length);
    return betweenString;
}
function getEmailAddress(data) {
    const emails = data.match(/(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))/g);
    return emails ? emails[0] : "";
}
function phoneNumbers(data) {
    let numbers = data.match(/(\d{3}[-\.\s]??\d{3}[-\.\s]??\d{4}|\(\d{3}\)\s*\d{3}[-\.\s]??\d{4}|\d{3}[-\.\s]??\d{4})/g);
    if (numbers) {
        for (let nIndex = 0; nIndex < numbers.length; nIndex++) {
            const num = numbers[nIndex];
            if (num.indexOf("(") === -1) {
                numbers.splice(nIndex, 1);
                --nIndex;
            }
        }
    }
    //Return numbers
    return numbers;
}
// Build the Date from calendar parts so the day is identical in every timezone.
// `new Date("YYYY-MM-DD")` is parsed as UTC midnight, which reads back as the
// previous day for users behind UTC — the copy-paste DOB off-by-one. Slash and
// "MM-DD-YYYY" tokens already parse as local midnight, so their value is
// unchanged; this just makes every shape explicit and timezone-safe.
function makeLocalDate(year, month, day) {
    if (month < 1 || month > 12 || day < 1 || day > 31) {
        // Out-of-range (e.g. an SSN fragment the outer regex also matches) → invalid
        // so getDOB keeps scanning for the real date, matching the old new Date().
        return new Date(NaN);
    }
    return new Date(year, month - 1, day);
}
function buildLocalDate(value) {
    // Year-first (YYYY-MM-DD / YYYY/MM/DD) is the one shape new Date() treats as
    // UTC; year-last (MM/DD/YYYY) it treats as local. Match either anywhere in the
    // token (the value can carry surrounding punctuation, e.g. ": 09/10/1932").
    const iso = value.match(/(\d{4})[.\-/ ](\d{1,2})[.\-/ ](\d{1,2})/);
    if (iso) {
        return makeLocalDate(+iso[1], +iso[2], +iso[3]);
    }
    const us = value.match(/(\d{1,2})[.\-/ ](\d{1,2})[.\-/ ](\d{4})/);
    if (us) {
        return makeLocalDate(+us[3], +us[1], +us[2]);
    }
    return new Date(NaN);
}
function getDOB(data, isOne = false) {
    let findDOB = "";
    //Data not found
    if (!data) {
        return findDOB;
    }
    let dates = data.match(/(\d{4}([.\-/ ])\d{2}\2\d{2}|\d{2}([.\-/ ])\d{2}\3\d{4})/g);
    if (isOne) {
        dates = [data];
    }
    //**Return*/
    if (!dates) {
        return;
    }
    for (const dtf of dates) {
        const dt = buildLocalDate(dtf);
        if (dt.toString() !== "Invalid Date") {
            findDOB = dt;
            break;
        }
    }
    return findDOB;
}
function copyText(value) {
    const el = document.createElement("textarea");
    el.value = value;
    el.setAttribute("readonly", "");
    el.style.position = "absolute";
    el.style.left = "-9999px";
    document.body.appendChild(el);
    el.select();
    document.execCommand("copy");
    document.body.removeChild(el);
}
function isString(text) {
    if (text) {
        return text;
    }
    //Return Blank string
    return "";
}
